export default __webpack_public_path__ + "static/New Year Sleep Resolution-1e3ebb189533beef9b245c1516dee717.jpg";